export default __webpack_public_path__ + "static/tag-dont-5-light-9241c43e518808d8afbeb4534e589025.png";